export const enum SearchActions {
    setStatus = '@FAQSearch/setStatus',
    setResult = '@FAQSearch/setResult',
    clear = '@FAQSearch/clear',
}
